import ProjectDistributionsPage from "./ProjectDistributionsPage"

export default ProjectDistributionsPage
